// @ts-expect-error not migrated to TS yet
import BannerContainer from 'EmailComponents/BannerContainer';
// @ts-expect-error not migrated to TS yet
import ChartsExportButton from 'EmailComponents/ChartsExportButton';
// @ts-expect-error not migrated to TS yet
import ErrorBoundary from 'EmailComponents/errors/ErrorBoundary';
import CompareEmailsButton from 'EmailComponents/compareEmails/CompareEmailsButton';
import CreateEmailButtonContainer from 'EmailComponents/emailCreation/CreateEmailButtonContainer';
import MoreToolsButtonContainer from 'EmailComponents/moreTools/MoreToolsButtonContainer';
import PortalSuspensionBadge from 'EmailComponents/status/PortalSuspensionBadge';
import { getUsageTracker } from 'EmailComponents/utils/tracking';
import { navigateTo } from 'EmailComponents/utils/urlUtils';
import { APP_PATHS } from 'EmailData/constants/app';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PortalIdParser from 'PortalIdParser';
import { Header as LibHeader } from 'foundations-components/transitional/components/Header';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { NavMarker } from 'react-rhumb';
import emptyFunction from 'react-utils/emptyFunction';
import MC0653EmailSendsCounter from 'ui-addon-upgrades/mc-0653/MC0653EmailSendsCounter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ROOT_URL = `/email/${PortalIdParser.get()}`;
const getTabName = path => {
  if (path.indexOf(APP_PATHS.MANAGE_TAB) >= 0) {
    return APP_PATHS.MANAGE_TAB;
  } else if (path.indexOf(APP_PATHS.ANALYZE_TAB) >= 0) {
    return APP_PATHS.ANALYZE_TAB;
  } else if (path.indexOf(APP_PATHS.HEALTH_TAB) >= 0) {
    return APP_PATHS.HEALTH_TAB;
  }
  return '';
};
class Header extends Component {
  constructor(props) {
    super(props);
    const {
      fetchFunc,
      source
    } = props;
    this.onManageTabClick = source === 'email-management' ? this.onTabClick.bind(this, {
      fetchFn: fetchFunc,
      path: APP_PATHS.MANAGE_TAB
    }) : () => navigateTo(`${ROOT_URL}${APP_PATHS.MANAGE_TAB}`);
    this.onAnalyzeTabClick = !source || source === 'email' ? this.onTabClick.bind(this, {
      path: APP_PATHS.ANALYZE_TAB
    }) : () => navigateTo(`${ROOT_URL}${APP_PATHS.ANALYZE_TAB}`);
    this.onHealthTabClick = !source || source === 'health' ? this.onTabClick.bind(this, {
      path: APP_PATHS.HEALTH_TAB
    }) : () => navigateTo(`${ROOT_URL}${APP_PATHS.HEALTH_TAB}`);
  }
  onTabClick({
    path,
    fetchFn = emptyFunction
  }) {
    const {
      updateQueryAndPathParams
    } = this.props;
    if (updateQueryAndPathParams !== undefined) {
      updateQueryAndPathParams({}, {}, fetchFn, path, true);
    }
  }
  renderTabs() {
    const {
      location: {
        pathname
      },
      isFree,
      isInNewUserState
    } = this.props;
    const selectedTab = getTabName(pathname);
    return /*#__PURE__*/_jsx(Fragment, {
      children: (!isInNewUserState || !isFree) && /*#__PURE__*/_jsxs(Tabs, {
        selected: selectedTab,
        marginBlockEnd: selectedTab === APP_PATHS.ANALYZE_TAB ? '25' : undefined,
        bordered: false,
        children: [/*#__PURE__*/_jsx(Tab, {
          onClick: this.onManageTabClick,
          tabId: APP_PATHS.MANAGE_TAB,
          title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "EmailComponents.header.tabs.manage"
          })
        }), /*#__PURE__*/_jsx(Tab, {
          onClick: this.onAnalyzeTabClick,
          tabId: APP_PATHS.ANALYZE_TAB,
          title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "EmailComponents.header.tabs.analyze"
          })
        }), /*#__PURE__*/_jsx(Tab, {
          onClick: this.onHealthTabClick,
          tabId: APP_PATHS.HEALTH_TAB,
          title: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "EmailComponents.header.tabs.health"
            }), /*#__PURE__*/_jsx(PortalSuspensionBadge, {})]
          })
        })]
      })
    });
  }
  renderTitle() {
    const {
      EmailHeaderSubtitle
    } = this.props;
    return EmailHeaderSubtitle ? /*#__PURE__*/_jsx(EmailHeaderSubtitle, {
      title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.header.title"
      })
    }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "EmailComponents.header.title"
    });
  }
  render() {
    const {
      AsyncMoreToolsModalContainer,
      autoStartOnboarding,
      showExport,
      exportCharts,
      isFree,
      isStarter,
      shouldRenderMoreToolsButton,
      setComparisonToolReturnLocation,
      updateQueryAndPathParams,
      location,
      limitsOpen,
      overrideMergedEditorHref,
      whitelistingOpen,
      router,
      portalCreditsUsed,
      showMc0653Variation,
      emailCreationComponent
    } = this.props;
    return /*#__PURE__*/_jsxs(LibHeader, {
      details: /*#__PURE__*/_jsx(ErrorBoundary, {
        type: "info",
        children: /*#__PURE__*/_jsx(BannerContainer, {
          hideBannerForMc0653Experiment: showMc0653Variation
        })
      }),
      tabs: this.renderTabs(),
      title: this.renderTitle(),
      use: "condensed",
      children: [showMc0653Variation && /*#__PURE__*/_jsx(MC0653EmailSendsCounter, {
        value: portalCreditsUsed,
        limit: 2000
      }), showExport && /*#__PURE__*/_jsx(ChartsExportButton, {
        doExport: exportCharts
      }), shouldRenderMoreToolsButton ? /*#__PURE__*/_jsx(MoreToolsButtonContainer, {
        allowlistingOpen: whitelistingOpen,
        AsyncMoreToolsModalContainer: AsyncMoreToolsModalContainer,
        isFree: isFree !== undefined ? isFree : false,
        isStarter: isStarter !== undefined ? isStarter : false,
        limitsOpen: limitsOpen,
        router: router,
        selectedTab: getTabName(location.pathname),
        setComparisonToolReturnLocation: setComparisonToolReturnLocation !== undefined ? setComparisonToolReturnLocation : emptyFunction,
        tracker: getUsageTracker(),
        updateQueryAndPathParams: updateQueryAndPathParams !== undefined ? updateQueryAndPathParams : emptyFunction
      }) : /*#__PURE__*/_jsx(CompareEmailsButton, {
        isFree: isFree !== undefined ? isFree : false,
        isStarter: isStarter !== undefined ? isStarter : false,
        selectedTab: getTabName(location.pathname),
        setComparisonToolReturnLocation: setComparisonToolReturnLocation !== undefined ? setComparisonToolReturnLocation : emptyFunction,
        tracker: getUsageTracker(),
        updateQueryAndPathParams: updateQueryAndPathParams !== undefined ? updateQueryAndPathParams : emptyFunction
      }), /*#__PURE__*/_jsx(NavMarker, {
        name: "CREATE_EMAIL_BUTTON_LOADED",
        children: /*#__PURE__*/_jsx(ErrorBoundary, {
          type: "alert",
          children: /*#__PURE__*/_jsx(CreateEmailButtonContainer, {
            autoStartOnboarding: autoStartOnboarding,
            overrideMergedEditorHref: overrideMergedEditorHref,
            emailCreationComponent: emailCreationComponent
          })
        })
      })]
    });
  }
}
Header.propTypes = {
  AsyncMoreToolsModalContainer: PropTypes.func,
  EmailHeaderSubtitle: PropTypes.func,
  autoStartOnboarding: PropTypes.bool,
  className: PropTypes.string,
  exportCharts: PropTypes.func,
  fetchFunc: PropTypes.func,
  isFree: PropTypes.bool,
  isInNewUserState: PropTypes.bool,
  isStarter: PropTypes.bool,
  limitsOpen: PropTypes.bool.isRequired,
  location: PropTypes.object,
  overrideMergedEditorHref: PropTypes.string,
  setComparisonToolReturnLocation: PropTypes.func,
  shouldRenderMoreToolsButton: PropTypes.bool,
  showExport: PropTypes.bool,
  updateQueryAndPathParams: PropTypes.func,
  whitelistingOpen: PropTypes.bool.isRequired,
  source: PropTypes.oneOf(['email', 'health', 'email-management']),
  router: PropTypes.object
};
Header.defaultProps = {
  fetchFunc: emptyFunction,
  isFree: false,
  isStarter: false,
  shouldRenderMoreToolsButton: false,
  setComparisonToolReturnLocation: emptyFunction,
  showExport: false,
  updateQueryAndPathParams: emptyFunction
};
export default Header;